import React from 'react';
import { PURCHASE_ORDER_PERMISSIONS } from 'pages/PurchaseOrder/helpers/constants';
import { PURCHASE_ORDER_PERMISSIONS as PURCHASE_ORDER_RETURN_PERMISSIONS } from 'pages/PurchaseOrderReturned/helpers/constants';

const AccountingReportPage = React.lazy(() => import('pages/AccountingReports/AccountingReportPage'));
const PurchaseOrders = React.lazy(() => import('pages/PurchaseOrder/PurchaseOrders'));
const PurchaseOrdersAdd = React.lazy(() => import('pages/PurchaseOrder/PurchaseOrdersAdd'));
const PurchaseOrdersReturned = React.lazy(() => import('pages/PurchaseOrderReturned/PurchaseOrdersReturned'));

const purchaseOrdersRoutes = [
  {
    path: '/purchase-orders',
    exact: true,
    name: 'Danh sách đơn mua hàng',
    function: PURCHASE_ORDER_PERMISSIONS.VIEW,
    requireAssigned: true,
    component: PurchaseOrders,
  },
  {
    path: '/purchase-report',
    exact: true,
    name: 'Báo cáo mua hàng',
    function: PURCHASE_ORDER_PERMISSIONS.VIEW,
    requireAssigned: true,
    component: AccountingReportPage,
  },
  {
    path: '/purchase-orders/add',
    exact: true,
    name: 'Thêm mới đơn mua hàng',
    function: PURCHASE_ORDER_PERMISSIONS.ADD,
    requireAssigned: true,
    component: PurchaseOrdersAdd,
  },
  {
    path: '/purchase-orders/edit/:id',
    exact: true,
    name: 'Chỉnh sửa đơn mua hàng',
    function: PURCHASE_ORDER_PERMISSIONS.EDIT,
    requireAssigned: true,
    component: PurchaseOrdersAdd,
  },
  {
    path: '/purchase-orders/detail/:id',
    exact: true,
    name: 'Chi tiết đơn mua hàng',
    function: [PURCHASE_ORDER_PERMISSIONS.VIEW, PURCHASE_ORDER_PERMISSIONS.STOCK_IN_WINDOW_VIEW],
    any: true,
    requireAssigned: true,
    component: PurchaseOrdersAdd,
  },
  {
    path: '/purchase-orders-returned',
    exact: true,
    name: 'Danh sách đơn trả hàng',
    function: PURCHASE_ORDER_RETURN_PERMISSIONS.VIEW,
    component: PurchaseOrdersReturned,
  },
  {
    path: '/purchase-orders-returned/add',
    exact: true,
    name: 'Thêm mới đơn trả hàng',
    function: PURCHASE_ORDER_RETURN_PERMISSIONS.ADD,
    component: () => <PurchaseOrdersAdd isReturned={true} />,
  },
  {
    path: '/purchase-orders-returned/edit/:id',
    exact: true,
    name: 'Chỉnh sửa đơn trả hàng',
    function: PURCHASE_ORDER_RETURN_PERMISSIONS.EDIT,
    component: () => <PurchaseOrdersAdd isReturned={true} />,
  },
  {
    path: '/purchase-orders-returned/detail/:id',
    exact: true,
    name: 'Chi tiết đơn trả hàng',
    function: PURCHASE_ORDER_RETURN_PERMISSIONS.VIEW,
    component: () => <PurchaseOrdersAdd isReturned={true} />,
  },
];

export default purchaseOrdersRoutes;
